module.exports = __webpack_public_path__ + "front/img/menu5.4cd02008.png";